import { KeyConstructor } from './keyConstructor';
const POST_MODERATION_ITEMS_KEY = 'postModerationsItem';
const MODERATION_ITEM_KEY = 'moderationItem';
const MODERATION_ITEMS_KEY = 'moderationItems';
const MODERATION_ITEM_REPORTERS_KEY = 'moderationItemReporters';
const MODERATION_SETTINGS_KEY = 'moderationSettings';
export const getPostModerationItemsKey = KeyConstructor(POST_MODERATION_ITEMS_KEY);
export const getModerationItemKey = KeyConstructor(MODERATION_ITEM_KEY);
export const getModerationItemsKey = KeyConstructor(MODERATION_ITEMS_KEY);
export const getModerationItemReportersKey = KeyConstructor(MODERATION_ITEM_REPORTERS_KEY);
export const getModerationSettingsKey = KeyConstructor(MODERATION_SETTINGS_KEY);
//# sourceMappingURL=moderation.key.js.map